type Translate = (key: string) => string;

export function submitterLabel(
  t: Translate,
  record: { source?: SupplementKnowledge.Source; submittedUserName?: string | null },
): string {
  if (record.source === 'CIH_HISTORY_CUSTOMER') return t('supplement.list.aiKnowledgeMiningEngine');
  return record.submittedUserName?.trim() || '-';
}

export function operationActorLabel(
  t: Translate,
  source: SupplementKnowledge.Source,
  operationType: SupplementKnowledge.OperationType,
  userName: string,
): string {
  // 空姓名只能在 CIH 原始提交事件中补全，后续人工操作仍使用真实操作人。
  if (
    userName.trim() === 'CIH' ||
    (!userName.trim() && source === 'CIH_HISTORY_CUSTOMER' && operationType === 'SUBMIT_KNOWLEDGE')
  ) {
    return t('supplement.list.aiKnowledgeMiningEngine');
  }
  return userName;
}
